module.exports = {
    Namespace: require('./lib/namespaces'),
    MUC: require('./lib/muc'),
    PubSub: require('./lib/pubsub'),
    Jingle: require('./lib/jingle'),
    Presence: require('./lib/presence')
};



//////////////////
// WEBPACK FOOTER
// /home/dani/kaiwa/~/xmpp-constants/index.js
// module id = 452
// module chunks = 2